import styled from "styled-components";
import { size } from "styled-theme";

const Wrapper = styled.div`
  height: 80px;

  
  &.extend-footer {
    height: 156px;
  }

  @media only screen and (max-width: ${size("S")}) {
    height: 110px;
    
    &.extend-footer {
      height: 186px;
    }
  }
`;

export default Wrapper;
